<template>
  <label class="block checkbox" :class="{ 'indetermined': partial }">
    <slot />
    <input type="checkbox" v-model="proxyValue" @change="handleChanged" />
    <span class="checkmark"></span>
  </label>
</template>

<script>
export default {
  props: ['value', 'partial'],
  data () {
    return {
      proxyValue: this.value
    }
  },
  methods: {
    handleChanged (e) {
      this.$nextTick(() => {
        this.$emit('change', e.target.checked)
      })
    }
  },
  watch: {
    value (val) {
      this.proxyValue = val
    },
    proxyValue: {
      handler(val) {
        this.$emit('input', val)
      },
      immediate: true
    }
  }
}
</script>